import React, { useState, useEffect } from "react";

import { API_URL, createMarkup, setValToLS, getValFromLS } from "../helpers";

import Hdg from "../components/Hdg";
import Nav from "../components/Nav";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Assets from "./Assets";
import Leaderboard from "./Leaderboard";

const ToolsResources = () => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		token: "",
	});
	const [msg, setMsg] = useState({});
	const [html, setHtml] = useState({});
	const [showLeaderboard, setShowLeaderboard] = useState(false);
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/htmlInit`);
		const params = {
			left: `tools-resources`,
			right: `right-featured-birdies`,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				if (
					getValFromLS("toolsHtml", true) &&
					getValFromLS("toolsData", true)
				) {
					setHtml(JSON.parse(getValFromLS("toolsHtml", true)));
					setNames(JSON.parse(getValFromLS("toolsData", true)));
				} else {
					setHtml({
						left: json.left,
						right: json.right,
					});
				}
				setShowLeaderboard(json.showLeaderboard);
				setAlert({});
				window.jQuery(".cycle-slideshow").cycle("stop");
				window.jQuery(".cycle-slideshow").cycle();
			} else {
				setAlert({
					type: json.resp === 2 ? "notice" : "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/toolsSignin`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS(
					"toolsHtml",
					JSON.stringify({
						left: json.left,
						right: json.right,
					}),
					true,
				);
				setValToLS(
					"toolsData",
					JSON.stringify({ data: json.data, token: json.token }),
					true,
				);
				setHtml({
					left: json.left,
					right: json.right,
				});
				setNames({ data: json.data, token: json.token });
				setMsg({});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg />
						<Nav />
						{html.left && (
							<div dangerouslySetInnerHTML={createMarkup(html.left)} />
						)}
						{!names.token && (
							<form
								method="post"
								action="/"
								onSubmit={(e) => handleSubmit(e)}
								className="well"
								style={{ marginBottom: "30px" }}
							>
								<span>Please enter your password to continue.</span>
								<div className="form-group" style={{ marginTop: "10px" }}>
									<Input
										type="password"
										label="Password"
										reqd={true}
										name="pwd"
										value={""}
										update={handleUpdate}
										errors={errors}
										placeholder="Enter password"
									/>
								</div>

								<div className="msg-submit">
									{msg.type && <Msg data={msg} />}

									<div
										className={
											msg.type === "working" || msg.type === "success"
												? "hidden"
												: "submit-container"
										}
									>
										<Submit submit="Submit" />
									</div>
								</div>
							</form>
						)}

						{names.data && showLeaderboard && <Leaderboard />}

						{names.data && <Assets array={names.data.images} name="Images" />}

						{names.data && (
							<Assets
								array={names.data.kickoff}
								name="Program Slide Presentations"
							/>
						)}

						{names.data && <Assets array={names.data.vip} name="VIP Info" />}

						{names.data && (
							<Assets array={names.data.webinars} name="Webinars" />
						)}

						{names.data && (
							<Assets
								array={names.data.address}
								name="Physical & Mailing Address Info"
							/>
						)}

						{names.data && (
							<Assets array={names.data.social} name="Social Media Images" />
						)}

						{names.data && (
							<Assets array={names.data.emails} name="Archived Emails" />
						)}

						{/*names.data && (
              <Assets array={names.data.dash} name="Dash to the VTO" />
            )*/}
					</div>
					<div
						id="right-column"
						dangerouslySetInnerHTML={createMarkup(html.right)}
					/>
				</>
			)}
		</>
	);
};

export default ToolsResources;
